module.exports = __webpack_public_path__ + "img/home2.74712c34.png";